var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconBookmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 19,
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.9574 3.33993C15.9574 2.77129 15.7618 2.27661 15.3712 1.85521C14.9806 1.43518 14.5163 1.22482 13.979 1.22482H3.3543C2.817 1.22482 2.35205 1.43518 1.96147 1.85521C1.57089 2.27661 1.37526 2.77129 1.37526 3.33993V16.9962L8.74003 12.2089L15.9574 16.9589V3.33993ZM16.2502 0.964929C16.8612 1.60821 17.1667 2.38789 17.1667 3.30261V19L8.74003 13.5076L0.166672 19V3.30261C0.166672 2.38789 0.472169 1.60821 1.08249 0.964929C1.69282 0.322321 2.42575 0 3.2806 0H14.0521C14.9076 0 15.6399 0.322321 16.2502 0.964929Z",
  fill: "white"
})));
export default SvgIconBookmark;